import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import en from './locales/en.json'
const i18n = createI18n({
    legacy: false, // obligatorio para Composition API
    locale: localStorage.getItem('lang') || 'es',
    fallbackLocale: 'en',
    messages: {
        es,
        en
    }
});
export default i18n